import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "section-header"
};
const _hoisted_2 = {
  class: "title-wrapper"
};
const _hoisted_3 = {
  class: "title-box"
};
export default /*@__PURE__*/_defineComponent({
  __name: 'BlueSectionTitle',
  props: {
    title: {
      type: String,
      required: true
    },
    showMore: {
      type: Boolean,
      default: true
    }
  },
  emits: ['more-click'],
  setup(__props, {
    emit: __emit
  }) {
    const emit = __emit;
    const handleMoreClick = () => {
      emit('more-click');
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(__props.title), 1), _cache[0] || (_cache[0] = _createElementVNode("div", {
        class: "title-underline"
      }, null, -1))]), _cache[1] || (_cache[1] = _createElementVNode("div", {
        class: "title-line"
      }, null, -1)), __props.showMore ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: "more-btn",
        onClick: handleMoreClick
      }, "更多+")) : _createCommentVNode("", true)]);
    };
  }
});